import {
  toSectionCtaSingle,
  toSectionFeature,
  toSectionSlider
} from '@/lib/transformers'
import { Typo3SectionSpotSanityTour } from '@/types/typo3'
import { SpotSanityListTour } from '@/ui/components/SpotSanity/SpotSanity'
import { SectionCtaSingle, SectionFeature, SectionSlider } from '@/ui/Sections'
import { memo, Suspense } from 'react'
import Detail from './Layout/Detail'

interface Props {
  data: Typo3SectionSpotSanityTour
}

const SpotSanityNature = ({ data }: Props) => {
  const layout = data?.plugin?.layout

  switch (layout) {
    case 'horizontal-with-images': {
      const sectionData = toSectionFeature(data)
      return <SectionFeature {...sectionData} />
    }
    case 'photo-big': {
      const sectionData = toSectionCtaSingle(data)
      return <SectionCtaSingle {...sectionData} />
    }
    case 'photo-big-slide': {
      const sectionData = toSectionSlider(data)
      return <SectionSlider {...sectionData} />
    }
    case 'detail': {
      return <Detail data={data} />
    }
    default: {
      return (
        <Suspense>
          <SpotSanityListTour data={data} />
        </Suspense>
      )
    }
  }
}

export default memo(SpotSanityNature)
